export default __webpack_public_path__ + "static/media/OA Logo.82f5da93.png";